// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"142":"44c751a8","275":"7d5bc0dd","458":"b7c56a39","885":"3dd29c18","912":"1977ee35","934":"4361b97f"}[chunkId] + ".js";
};